import {connect} from 'react-redux'
import ProposedRoutes from "../../Components/ProposedRoutes/ProposedRoutes";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";

const mapStateToProps = (store) => {
    return {
        isEvaluatingDeliveryGroups: store.deliveryGroupsReducer.evaluatingProposedDeliveryGroups,
        lockedDeliveryGroups: store.deliveryGroupsReducer.lockedDeliveryGroups
    };
};

const mapDispatchToProps = {
    lockDeliveryGroup: deliveryGroupsActions.lockDeliveryGroup,
    unlockDeliveryGroup: deliveryGroupsActions.unlockDeliveryGroup
};

const ProposedRoutesContainer = connect(mapStateToProps, mapDispatchToProps)(ProposedRoutes);

export default ProposedRoutesContainer;